import { useMutation } from '@tanstack/react-query';
import { useDocumentCache } from 'entities/document/api/hooks/use-document-cache';
import { deleteDocument } from '../requests';

export const useDeleteDocument = () => {
  const { refetchAllDocumentsQueries } = useDocumentCache();

  return useMutation({
    mutationFn: deleteDocument,
    onSuccess: refetchAllDocumentsQueries,
  });
};
